import type { Zone, ZoneCreate, ZoneUpdate } from './@types/ZoneModel';
export class ZoneRepo {
    private httpService: IHttpService;
    constructor(instance: IHttpService) {
        this.httpService = instance;
    }
    async getZones(): Promise<Zone[]> {
        try {
            const response = await this.httpService.get<TKResponse<Zone[]>>('/zones');
            return response.data
                .map((zone: Zone) => ({ ...zone, id: zone.zone_id }))
                .sort((a, b) => ((a as any).name ?? '').localeCompare((b as any).name ?? ''));
        } catch (error) {
            console.error('Error al obtener las zonas:', error);
            throw error;
        }
    }

    async getZoneById(zoneId: number): Promise<Zone> {
        try {
            const response = await this.httpService.get<TKResponse<Zone>>(`/zones/${zoneId}`);
            return { ...response.data, id: response.data.zone_id };
        } catch (error) {
            console.error(`Error al obtener la zona con ID ${zoneId}:`, error);
            throw error;
        }
    }

    async createZone(data: ZoneCreate): Promise<Zone> {
        try {
            const response = await this.httpService.post<TKResponse<Zone>, ZoneCreate>('/zones', { data });
            return response.data
        } catch (error) {
            console.error('Error al crear la zona:', error);
            throw error;
        }
    }

    async updateZone(zoneId: number, data: ZoneUpdate): Promise<Zone> {
        try {
            const response = await this.httpService.patch<TKResponse<Zone>, ZoneUpdate>(`/zones/${zoneId}`, { data });
            return { ...response.data, id: response.data.zone_id };
        } catch (error) {
            console.error(`Error al actualizar la zona con ID ${zoneId}:`, error);
            throw error;
        }
    }

    async deleteZone(zoneId: number): Promise<void> {
        try {
            await this.httpService.delete<void>(`/zones/${zoneId}`);
        } catch (error) {
            console.error(`Error al eliminar la zona con ID ${zoneId}:`, error);
            throw error;
        }
    }
}
